module.exports = __webpack_public_path__ + "static/media/LOGO_NEW_Path_Utility.8d2dd35d.png";